import { Component, OnInit } from '@angular/core';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TravelDocumentService } from 'projects/clooper/core/src/public-api';

@Component({
  selector: 'app-remove-document-modal',
  templateUrl: './remove-document-modal.component.html',
  styleUrls: ['./remove-document-modal.component.scss']
})
export class RemoveDocumentModalComponent implements OnInit {
  icons = { close: faTimes };
  documentId: string;
  submitting = false;
  onRemoved: () => void;

  constructor(
    public bsModalRef: BsModalRef,
    private travelDocumentService: TravelDocumentService
  ) {}

  ngOnInit(): void {}

  close(): void {
    this.bsModalRef?.hide();
  }

  confirm(): void {
    console.log('RemoveDocumentModal confirm() called, documentId:', this.documentId);
    if (!this.documentId || this.submitting) {
      console.warn('Aborting: documentId is', this.documentId, 'submitting is', this.submitting);
      return;
    }

    this.submitting = true;
    this.travelDocumentService.deleteTravelDocument(this.documentId).subscribe({
      next: (response) => {
        console.log('Document deleted successfully:', response);
        this.submitting = false;
        // Call the onRemoved callback to trigger document refresh
        if (this.onRemoved) {
          this.onRemoved();
        }
        // Close modal - parent component will handle the refetch
        this.close();
      },
      error: (err) => {
        console.error('Failed to delete document:', err);
        this.submitting = false;
      }
    });
  }
}
